const navLinkConfirmCreateUser = {
  text: 'Regrese a la página de inicio para ingresar'
};

export default navLinkConfirmCreateUser;
